import { render, staticRenderFns } from "./claimStatusHistoryDisplay.vue?vue&type=template&id=d19a60a2&"
import script from "./claimStatusHistoryDisplay.vue?vue&type=script&lang=js&"
export * from "./claimStatusHistoryDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports